/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Region } from '../../models/region';

export interface UpdateRegion$Params {
  id: string;
      body?: Region
}

export function updateRegion(http: HttpClient, rootUrl: string, params: UpdateRegion$Params, context?: HttpContext): Observable<StrictHttpResponse<Region>> {
  const rb = new RequestBuilder(rootUrl, updateRegion.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Region>;
    })
  );
}

updateRegion.PATH = '/region/{id}';
